import Reveal from "@/components/site/Reveal";
import { CATEGORIES } from "@/lib/content";
import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";

export default function Collection() {
    return (
        <section
            data-testid="collection-section"
            className="bg-[#0a0a0a] text-white px-6 sm:px-10 lg:px-16 py-24 lg:py-32 border-t border-white/10"
        >
            <div className="flex flex-col lg:flex-row lg:items-end justify-between gap-8 mb-16 lg:mb-24">
                <div className="max-w-3xl">
                    <Reveal>
                        <p className="text-[11px] uppercase tracking-[0.3em] text-white/50 mb-8">
                            03 · The Collection
                        </p>
                    </Reveal>
                    <Reveal delay={0.1}>
                        <h2 className="font-serif text-5xl sm:text-6xl lg:text-7xl font-medium leading-[0.95] tracking-tight">
                            Five houses,
                            <br />
                            one roof.
                        </h2>
                    </Reveal>
                </div>
                <Reveal delay={0.2}>
                    <Link
                        to="/collection"
                        data-testid="collection-view-all"
                        className="group inline-flex items-center gap-4 border border-white/30 px-8 py-4 text-[11px] uppercase tracking-[0.28em] hover:bg-white hover:text-black transition-all duration-500 whitespace-nowrap"
                    >
                        View Full Collection
                        <ArrowUpRight
                            size={14}
                            className="transition-transform duration-500 group-hover:rotate-45"
                        />
                    </Link>
                </Reveal>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-12 gap-4 lg:gap-6">
                {CATEGORIES.map((cat, idx) => {
                    const spans = [
                        "lg:col-span-5 lg:row-span-2",
                        "lg:col-span-4",
                        "lg:col-span-3",
                        "lg:col-span-4",
                        "lg:col-span-3",
                    ];
                    const heights = [
                        "h-[80vh]",
                        "h-[38vh]",
                        "h-[38vh]",
                        "h-[38vh]",
                        "h-[38vh]",
                    ];
                    return (
                        <Reveal
                            key={cat.slug}
                            delay={idx * 0.08}
                            y={60}
                            className={`${spans[idx]} relative group overflow-hidden ${heights[idx]}`}
                        >
                            <Link
                                to="/collection"
                                data-testid={`category-card-${cat.slug}`}
                                className="block w-full h-full relative"
                            >
                                <img
                                    src={cat.image}
                                    alt={cat.title}
                                    className="absolute inset-0 w-full h-full object-cover grayscale transition-transform duration-[1600ms] ease-out group-hover:scale-105"
                                />
                                <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/20 to-black/20 transition-opacity duration-700 group-hover:from-black/60" />

                                {cat.custom && (
                                    <div
                                        className="absolute top-5 left-5 px-3 py-1 border border-white/50 text-[9px] uppercase tracking-[0.28em] text-white bg-black/30 backdrop-blur-sm"
                                        data-testid={`custom-tag-${cat.slug}`}
                                    >
                                        Custom-Made
                                    </div>
                                )}

                                <div className="absolute top-5 right-5 text-[10px] uppercase tracking-[0.28em] text-white/70 font-mono-custom">
                                    0{idx + 1}
                                </div>

                                <div className="absolute bottom-0 left-0 right-0 p-6 lg:p-8 flex items-end justify-between gap-4">
                                    <div className="transition-transform duration-700 group-hover:-translate-y-1">
                                        <h3 className="font-serif text-3xl lg:text-5xl font-medium tracking-tight leading-none">
                                            {cat.title}
                                        </h3>
                                        <p className="mt-3 text-[11px] uppercase tracking-[0.28em] text-white/60">
                                            {cat.sub}
                                        </p>
                                    </div>
                                    <span className="shrink-0 w-10 h-10 rounded-full border border-white/40 flex items-center justify-center transition-all duration-500 group-hover:bg-white group-hover:text-black group-hover:rotate-45">
                                        <ArrowUpRight size={14} />
                                    </span>
                                </div>
                            </Link>
                        </Reveal>
                    );
                })}
            </div>
        </section>
    );
}
